import { OPEN_PROMO_MODAL, CLOSE_PROMO_MODAL } from './types';

const initialState = { isOpen: false };

export default (state = initialState, { type }) => {
  switch (type) {
  case OPEN_PROMO_MODAL: {
    return {
      ...state,
      isOpen: true,
    };
  }
  case CLOSE_PROMO_MODAL: {
    return {
      ...state,
      isOpen: false,
    };
  }
  default: {
    return state;
  }
  }
};
